import React from "react";
import moment from "moment";

import { DevConfig } from "src/utils/config";

interface StockDetailTableProps {
    contents: {
        MESSAGE: string;
        CHANNEL_ID: string;
        MESSAGE_ID: string;
        CHANNEL_TITLE: string;
        REGIST_DT: string;
    }[];
}

const StockDetailTable: React.FC<StockDetailTableProps> = ({ contents }) => {
    const ClickLink = (path: string) => {
        window.open(path, "_blank");
    };    
    return (
        <div className="table">
            <table className="table table-white table-hover mt-4">
                <colgroup>
                    <col style={{width: "25%"}} />
                    <col style={{width: "55%"}} />
                    <col style={{width: "20%"}} />
                </colgroup>
                <thead>
                    <tr>
                        <th className="text-center text-black3"><p>채널</p></th>
                        <th className="text-center text-black3"><p>내용</p></th>
                        <th className="text-center text-black3"><p>시간</p></th>
                    </tr>
                </thead>
                <tbody>
                    {contents.map((content, index) => (
                        <tr key={index} onClick={() => ClickLink(`${DevConfig.TELEGRAM_URL}/${content.CHANNEL_ID}/${content.MESSAGE_ID}`)} style={{ cursor: "pointer" }}>
                            <td className="text-center">
                                <p className="text-black5 ellipsis-box">{content.CHANNEL_TITLE}</p>
                            </td>
                            <td>
                                <a className="d-flex align-items-center gap-2">
                                    <div className="txt d-flex align-items-center gap-2">
                                        <p className="text-black5 fw-semibold ellipsis-box flex-none"></p>
                                        <p className="text-black5 ellipsis-box">{content.MESSAGE}</p>
                                        </div>
                                </a>
                            </td>
                            <td className="text-center text-black2">{moment.utc(content.REGIST_DT).add(9, "hours").format("MM.DD HH:mm")}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default StockDetailTable;